import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

import { mediaQueries } from "../../styles/media.js";

// Every Layout's Center: the page width caps the content, and the gutters sit outside it.
// GlobalStyle makes box-sizing inherit, so the children are reset or they'd inherit content-box.
// The doubled class keeps a Center nested directly in another one on content-box.
const Root = styled.div`
  && {
    box-sizing: content-box;
  }

  max-inline-size: var(--center-max-inline-size);
  margin-inline-start: auto;
  margin-inline-end: auto;
  padding-inline-start: var(--juno-space-6);
  padding-inline-end: var(--juno-space-6);

  > * {
    box-sizing: border-box;
  }

  &[data-page-width="narrow"] {
    --center-max-inline-size: var(--juno-page-width-narrow);
  }

  &[data-page-width="regular"] {
    --center-max-inline-size: var(--juno-page-width-regular);
  }

  &[data-page-width="wide"] {
    --center-max-inline-size: var(--juno-page-width-wide);
  }

  &[data-page-width="wider"] {
    --center-max-inline-size: var(--juno-page-width-wider);
  }

  &[data-page-width="widest"] {
    --center-max-inline-size: var(--juno-page-width-widest);
  }

  ${mediaQueries.md} {
    padding-inline-start: var(--juno-space-12);
    padding-inline-end: var(--juno-space-12);
  }
`;

const Center = ({ children, pageWidth = "regular", ...props }) => (
  <Root data-page-width={pageWidth} {...props}>
    {children}
  </Root>
);

Center.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  pageWidth: PropTypes.oneOf(["narrow", "regular", "wide", "wider", "widest"]),
  as: PropTypes.elementType,
};

export default Center;
